// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"94f75021","488":"db49d318","581":"9dc31acf","715":"c269ac35","731":"e8c15606","805":"31c725c8"}[chunkId] + ".chunk.js";
};